// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const RUN_CUSTOM_MODEL_STEP_SHAPES = [
  {
    stepType: PipelineStepType.RUN_CUSTOM_MODEL,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      outputDatasets: {
        systemName: 'outputDatasets',
        displayName: 'Output datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      outputFiles: {
        systemName: 'outputFiles',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      predictionBatchFolderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      predictionBatchName: {
        kind: 'string',
        required: false
      },
      modelConfig: {
        kind: 'anything',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
